import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Anchor from 'Components/common/Anchor';
import Input from 'Components/common/Input';
import BasicButton from 'Components/common/BasicButton';
import ProductItem from './ProductItem';

import Dialog from 'Components/common/Dialog';

// Actions
import {
    hostDeliverToShip,
    shipmentShip,
    createInvoicePdf,
    savePickOrder,
    getPickOrderMessageList,
    oneKeyReadMessage,
} from 'Actions/host';
import {completeShippingPlan} from 'Actions/myOrder';
import {openNotification} from 'Actions/notification';
import {getAllSkuConditionList} from 'Actions/host';
import {Checkbox} from '@material-ui/core';

// Icons
import {
    ArrowBackIos,
    RadioButtonChecked,
    RadioButtonUnchecked,
} from '@material-ui/icons';
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';
import {batchRecommendPdfsUrl} from 'Utils/urlUtil';
import {FROM_PAGE} from 'Utils/constant';
import {orderAdd} from '../../utils/urlUtil';

const SHIPMENT_LIST_RESTORE_STORAGE_KEY = 'shipmentListRestoreState';

class ShipEdit extends React.Component {
    state = {
        orderDetails: {},
        products: {},
        isShowPrice: true,
        expressNumber: '',
        submitBtnLoaded: true,
        f1OrderShipData: [],
        confirmShipData: [],
        shipExitOpened: false,
        disabledSubmitBtn: true,
        confirmShipmentDialogOpened: false,
        shipmentCount: 0,
        checkAll: false,
        previewPickOrderDialog: false,
        currentOrderIdMessageList: [],
        completedShippingPlanDialog: false,
        currentPlanId: 0,
    };

    componentWillMount() {
        // if (this.state.orderMessageListDialog) {
        //     let routerState = util.getRouterState(this.props.history.location.state);
        //     let currentEoneNum = typeof routerState.eoneNumber !== 'undefined' ? routerState.eoneNumber : '';
        //     this.props.getPickOrderMessageList({id: this.props.match.params.id}).then(res => {
        //         if (res && res.status === 'success') {
        //             if (res.data.length > 0) {
        //                 this.setState({
        //                     currentOrderIdMessageList: res.data,
        //                     currentEoneNum: currentEoneNum
        //                 });
        //             } else {
        //                 this.setState({
        //                     orderMessageListDialog: false,
        //                     currentOrderIdMessageList: []
        //                 })
        //             }
        //         }
        //     });
        // }
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        let currentEoneNum =
            typeof routerState.eoneNumber !== 'undefined'
                ? routerState.eoneNumber
                : '';
        this.props
            .getPickOrderMessageList({id: this.props.match.params.id})
            .then((res) => {
                if (res && res.status === 'success') {
                    if (res.data.length > 0) {
                        this.setState({
                            orderMessageListDialog: true,
                            currentOrderIdMessageList: res.data,
                            currentEoneNum: currentEoneNum,
                        });
                    } else {
                        this.getShipmentInfor();
                        this.setState({
                            orderMessageListDialog: false,
                            currentOrderIdMessageList: [],
                        });
                    }
                }
            });
    }

    initDeliverOrderQuantiys = (params) => {
        if (
            params.shipmentItem.product &&
            params.shipmentItem.product.kitFlag
        ) {
            if (
                params.shipmentItem.product &&
                params.shipmentItem.product.componentList &&
                params.shipmentItem.product.componentList.length > 0
            ) {
                params.shipmentItem.product.componentList.map(
                    (parentComItem, parentComIndex) => {
                        if (
                            parentComItem.inventoryDetails &&
                            parentComItem.inventoryDetails.length > 0
                        ) {
                            parentComItem.inventoryDetails.map(
                                (subComItem, subComIndex) => {
                                    subComItem.quantity =
                                        subComItem.suggestQuantity
                                            ? subComItem.suggestQuantity
                                            : 0;
                                },
                            );
                        }
                    },
                );
            }
        } else {
            if (
                params.shipmentItem.product &&
                params.shipmentItem.product.inventoryDetails &&
                params.shipmentItem.product.inventoryDetails.length > 0
            ) {
                params.shipmentItem.product.inventoryDetails.map(
                    (detailItem, detailIndex) => {
                        detailItem.quantity = detailItem.suggestQuantity
                            ? detailItem.suggestQuantity
                            : 0;
                    },
                );
            }
        }
    };

    getShipmentListRestoreTab = () => {
        let restoreTab = '';
        const routerState = util.getRouterState(
            this.props.history.location.state,
        );

        try {
            const restoreStateStr = sessionStorage.getItem(
                SHIPMENT_LIST_RESTORE_STORAGE_KEY,
            );
            const restoreState = restoreStateStr
                ? JSON.parse(restoreStateStr)
                : null;

            restoreTab =
                restoreState && restoreState.tab ? restoreState.tab : '';
        } catch (err) {}

        if (!restoreTab && routerState.returnToShipmentListTab) {
            restoreTab = routerState.returnToShipmentListTab;
        }

        return restoreTab;
    };

    goBack = () => {
        const {orderDetails} = this.state;
        const restoreTab = this.getShipmentListRestoreTab();

        if (restoreTab) {
            this.props.history.replace(`/shipmentList/${restoreTab}`);
            return;
        }

        if (orderDetails.status === 2) {
            this.props.history.replace('/shipmentList/onHold');
        } else {
            this.props.history.replace('/shipmentList/toBeShip');
        }
    };

    shipmentLotConfirmHandle = () => {
        this.setState({
            confirmShipmentDialogOpened: true,
        });
    };

    shipmentLotHandle = () => {
        const {expressNumber, orderDetails, isShowPrice} = this.state;

        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        this.setState({submitBtnLoaded: false});
        let shipData = {
            orderId: orderDetails.id,
            displayPrice: isShowPrice ? 1 : 2,
            expressNumber: expressNumber,
            forceShip:
                typeof routerState.forceShip !== 'undefined'
                    ? routerState.forceShip
                    : false,
        };

        let shipmentProductsArr = [];
        orderDetails.orderProducts &&
            orderDetails.orderProducts.forEach((orderProduct) => {
                let shipmentProductItems = [];
                if (orderProduct.product && orderProduct.product.kitFlag) {
                    if (
                        typeof orderProduct.product.componentList !==
                            'undefined' &&
                        orderProduct.product.componentList &&
                        orderProduct.product.componentList.length > 0
                    ) {
                        orderProduct.product.componentList.map(
                            (parentComItem, parentComIndex) => {
                                if (
                                    parentComItem.inventoryDetails &&
                                    parentComItem.inventoryDetails.length > 0
                                ) {
                                    parentComItem.inventoryDetails.map(
                                        (subComItem, subComIndex) => {
                                            let shipmentLotItemObj = {
                                                suggestFlag:
                                                    subComItem.suggestFlag,
                                                lot: subComItem.lot,
                                                storeCondition:
                                                    parentComItem.storeCondition,
                                                shippingCondition:
                                                    parentComItem.shippingCondition,
                                                specifications:
                                                    parentComItem.specifications,
                                                quantity: subComItem.quantity,
                                                sku: subComItem.sku,
                                                lotExpirationDate:
                                                    subComItem.lotExpirationDate,
                                                ddnsaDate: subComItem.ddnsaDate,
                                                dnsaDate: subComItem.dnsaDate,
                                                holdStatus:
                                                    subComItem.holdStatus,
                                            };
                                            shipmentProductItems.push(
                                                shipmentLotItemObj,
                                            );
                                        },
                                    );
                                }
                            },
                        );
                    }
                } else {
                    if (
                        typeof orderProduct.product.inventoryDetails !==
                            'undefined' &&
                        orderProduct.product.inventoryDetails &&
                        orderProduct.product.inventoryDetails.length > 0
                    ) {
                        orderProduct.product.inventoryDetails.map(
                            (shipmentLotItem, shipmentLotIndex) => {
                                let shipmentLotItemObj = {
                                    suggestFlag: shipmentLotItem.suggestFlag,
                                    lot: shipmentLotItem.lot,
                                    storeCondition:
                                        orderProduct.product.storeCondition,
                                    shippingCondition:
                                        orderProduct.product.shippingCondition,
                                    specifications:
                                        orderProduct.product.specifications,
                                    quantity: shipmentLotItem.quantity,
                                    sku: shipmentLotItem.sku,
                                    lotExpirationDate:
                                        shipmentLotItem.lotExpirationDate,
                                    ddnsaDate: shipmentLotItem.ddnsaDate,
                                    dnsaDate: shipmentLotItem.dnsaDate,
                                    holdStatus: shipmentLotItem.holdStatus,
                                };
                                shipmentProductItems.push(shipmentLotItemObj);
                            },
                        );
                    }
                }
                let productObj = {
                    orderProductId: orderProduct.id,
                    productId: orderProduct.product.id,
                    sku: orderProduct.product.sku,
                    shipmentProductItems: shipmentProductItems,
                };

                if (
                    shipmentProductItems.length > 0 &&
                    orderProduct.product.checked
                ) {
                    shipmentProductsArr.push(productObj);
                }
            });
        shipData.shipmentProducts = shipmentProductsArr;

        if (shipmentProductsArr.length > 0) {
            let orderIds = [shipData.orderId];
            this.props
                .shipmentShip(shipData)
                .then((res) => {
                    if (res && res.status === 'success') {
                        this.props.openNotification(
                            T('notification_successful_delivery'),
                            'success',
                            {
                                testid: 'shipment-successful-delivery-notification',
                            },
                        );

                        // if (util.isIOS()) {
                        //     window.location.href =
                        //         window.location.origin +
                        //         '/pdf-preview/pdf-preview.html?url=' +
                        //         window.location.origin +
                        //         batchRecommendPdfsUrl +
                        //         '?orderIds=' + orderIds;
                        // } else {
                        //     window.open(
                        //         window.location.origin +
                        //             '/pdf-preview/pdf-preview.html?url=' +
                        //             window.location.origin +
                        //             batchRecommendPdfsUrl +
                        //             '?orderIds=' + orderIds,
                        //         '_blank',
                        //     );
                        //     this.goBack();
                        // }
                        this.props
                            .createInvoicePdf({id: res.data})
                            .then((resPdf) => {
                                if (util.isIOS()) {
                                    window.location.href =
                                        window.location.origin +
                                        '/pdf-preview/pdf-preview.html?url=' +
                                        window.encodeURIComponent(
                                            `${
                                                util.getImageRoot() +
                                                resPdf.data
                                            }`,
                                        );
                                } else {
                                    window.open(
                                        window.location.origin +
                                            '/pdf-preview/pdf-preview.html?url=' +
                                            window.encodeURIComponent(
                                                `${
                                                    util.getImageRoot() +
                                                    resPdf.data
                                                }`,
                                            ),
                                        '_blank',
                                    );

                                    this.goBack();
                                }
                            });
                    }
                })
                .catch((res) => {
                    this.setState({
                        confirmShipmentDialogOpened: false,
                        submitBtnLoaded: true,
                    });
                });
        } else {
            this.props.openNotification(T('shipment_cannot_be_null'), 'danger');
            this.setState({
                disabledSubmitBtn: true,
            });
        }
    };

    dialogDidClose = (dialog) => {
        if (dialog === 'completedShippingPlanDialog') {
            this.clearPlanId();
        }
        this.state[dialog] && this.setState({[dialog]: false});
    };

    checkShipQuantity = () => {
        const {products} = this.state;
        let disabled = true;

        Object.values(products).forEach((product) => {
            if (product.inputQuantity > 0) disabled = false;
        });

        return disabled;
    };

    chooseRadio = (isCheck) => {
        const {displayPriceSetby} = this.state.orderDetails;

        if (displayPriceSetby === 1 || displayPriceSetby === 3) {
            this.props.openNotification(
                T('notification_order_cannot_be_operated'),
                'danger',
            );
        } else {
            this.setState({isShowPrice: isCheck});
        }
    };
    onChange = (title, value) => this.setState({[title]: value});

    shipmentSingleCheckHandle = (index, event) => {
        let currentOrderDetails = JSON.parse(
            JSON.stringify(this.state.orderDetails),
        );
        currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.map(
                (shipmentItem, shipmentIndex) => {
                    if (index === shipmentItem.id) {
                        if (event.target.checked) {
                            this.setState({
                                disabledSubmitBtn: false,
                            });
                        }
                        shipmentItem.product.checked = event.target.checked;
                    }
                },
            );

        let skuCount = 0;
        currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.map(
                (shipmentSkuItem, shipmentSkuIndex) => {
                    if (shipmentSkuItem.product.checked) {
                        skuCount = skuCount + 1;
                    }
                },
            );
        this.setState({
            orderDetails: currentOrderDetails,
            shipmentCount: skuCount,
        });
    };

    allSelectedShipmentHandle = (name) => (event) => {
        let currentOrderDetails = JSON.parse(
            JSON.stringify(this.state.orderDetails),
        );
        currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.map(
                (shipmentItem, shipmentIndex) => {
                    shipmentItem.product.checked = event.target.checked;
                },
            );
        let skuCount = 0;
        currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.map(
                (shipmentSkuItem, shipmentSkuIndex) => {
                    if (shipmentSkuItem.product.checked) {
                        skuCount = skuCount + 1;
                    }
                },
            );

        this.setState({
            disabledSubmitBtn: !event.target.checked,
            shipmentCount: skuCount,
            orderDetails: currentOrderDetails,
            checkAll: event.target.checked,
        });
    };

    inputValid = (key, value, item, subLotId) => {
        let currentOrderDetails = JSON.parse(
            JSON.stringify(this.state.orderDetails),
        );

        currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.map(
                (shipmentItem, shipmentIndex) => {
                    if (shipmentItem.id === item.id) {
                        if (
                            shipmentItem.product &&
                            shipmentItem.product.kitFlag
                        ) {
                            if (
                                shipmentItem.product &&
                                shipmentItem.product.componentList &&
                                shipmentItem.product.componentList.length > 0
                            ) {
                                shipmentItem.product.componentList.map(
                                    (parentComItem, parentComIndex) => {
                                        if (
                                            parentComItem.inventoryDetails &&
                                            parentComItem.inventoryDetails
                                                .length > 0
                                        ) {
                                            parentComItem.inventoryDetails.map(
                                                (subComItem, subComIndex) => {
                                                    if (
                                                        subComItem.id ===
                                                        subLotId
                                                    ) {
                                                        subComItem.quantity =
                                                            value;
                                                    }
                                                },
                                            );
                                        }
                                    },
                                );
                            }
                        } else {
                            if (
                                shipmentItem.product &&
                                shipmentItem.product.inventoryDetails &&
                                shipmentItem.product.inventoryDetails.length > 0
                            ) {
                                shipmentItem.product.inventoryDetails.map(
                                    (detailItem, detailIndex) => {
                                        if (detailItem.id === subLotId) {
                                            detailItem.quantity = value;
                                        }
                                    },
                                );
                            }
                        }
                    }
                },
            );

        this.setState({
            orderDetails: currentOrderDetails,
        });
    };

    shipmentPreviewPickOrderHandle = () => {
        let checkedCount = this.getCheckedSkuCount();
        if (checkedCount > 0) {
            this.setState({
                previewPickOrderDialog: true,
            });
        } else {
            this.props.openNotification(
                T('shipment_pick_please_select_preview_pick_order_sku'),
                'danger',
            );
        }
    };

    getCheckedSkuCount = () => {
        let currentOrderDetails = JSON.parse(
            JSON.stringify(this.state.orderDetails),
        );
        let checkedCount = 0;
        currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.forEach((orderDetailsItem) => {
                if (orderDetailsItem.product.checked) {
                    ++checkedCount;
                }
            });
        return checkedCount;
    };

    confirmPreviewPickOrderHandle = () => {
        let checkedSkuParamsArry = this.getCheckedSkuParams();

        this.props
            .savePickOrder(checkedSkuParamsArry)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState(
                        {
                            previewPickOrderDialog: false,
                        },
                        () => {
                            this.goBack(); //TODO 在发货页面 点击 预拣货 成功后是否跳转到 发货管理页面
                            this.props.openNotification(
                                T('shipment_preview_pick_order_success'),
                                'success',
                            );
                        },
                    );
                }
            })
            .catch((res) => {
                if (res && res.status === 'Empty_Sku_List ') {
                    this.props.openNotification(
                        T('shipment_preview_pick_order_sku_is_null'),
                        'danger',
                    );
                } else if (
                    res &&
                    res.status === 'ShipQuantity_Large_Then_TobeShipped'
                ) {
                    this.props.openNotification(
                        T(
                            'shipment_preview_delivered_quantity_greater_than__undelivered_quantity',
                            [res.message],
                        ),
                        'danger',
                    );
                } else if (res && res.status === 'Order_Not_Exist') {
                    //订单不存在
                    this.props.openNotification(
                        T('shipment_preview_order_non_existent'),
                        'danger',
                    );
                } else if (res && res.status === 'invalid_status') {
                    //订单状态不正确
                    this.props.openNotification(
                        T('shipment_preview_inconsistent_order_status'),
                        'danger',
                    );
                } else if (res && res.status === 'not_allowed') {
                    //订单类型不正确
                    this.props.openNotification(
                        T('shipment_preview_inconsistent_order_type'),
                        'danger',
                    );
                } else if (res && res.status === 'invalid_lock') {
                    //订单审核中或有锁
                    this.props.openNotification(
                        T('shipment_preview_lock_or_review_order'),
                        'danger',
                    );
                } else if (res && res.status === 'Order_Over_Picked') {
                    //订单已拣货
                    this.props.openNotification(
                        T('shipment_preview_order_has_been_picked'),
                        'danger',
                    );
                } else if (res && res.status === 'No_Component_Sku') {
                    //kit下的部分sku缺失
                    this.props.openNotification(
                        T('shipment_preview_no_component_sku'),
                        'danger',
                    );
                } else if (
                    res &&
                    res.status === 'Component_Quantity_Incorrect'
                ) {
                    //sku 数量不正确
                    this.props.openNotification(
                        T('shipment_preview_component_quantity_incorrect'),
                        'danger',
                    );
                } else if (res && res.status === 'Component_Suit_Incorrect') {
                    //component 套数不一致
                    this.props.openNotification(
                        T('shipment_preview_component_suit_incorrect'),
                        'danger',
                    );
                } else if (res && res.status === 'ShipQuantity_Zero') {
                    //某个sku 套数为0
                    this.props.openNotification(
                        T('shipment_preview_ship_quantity_zero'),
                        'danger',
                    );
                } else if (res && res.status === 'Ship_Quantity_Incorrect') {
                    //发货数量大于未发货数量
                    this.props.openNotification(
                        T('shipment_preview_ship_quantity_incorrect'),
                        'danger',
                    );
                }
                this.setState({
                    previewPickOrderDialog: false,
                });
            });
    };

    getCheckedSkuParams = () => {
        let currentOrderDetails = JSON.parse(
            JSON.stringify(this.state.orderDetails),
        );
        let pickOrderProductsArr = [];
        currentOrderDetails.orderProducts.length > 0 &&
            currentOrderDetails.orderProducts.forEach((orderDetailsItem) => {
                // console.log(orderDetailsItem);
                let pickOrderProduct = {};
                if (orderDetailsItem.product.checked) {
                    let currentinventoryId = 0;
                    let pickOrderProductItemsArry = [];
                    if (orderDetailsItem.product.kitFlag) {
                        if (
                            orderDetailsItem.product.componentList.length > 0 &&
                            orderDetailsItem.product.componentList[0]
                                .inventoryDetails.length > 0
                        ) {
                            currentinventoryId =
                                orderDetailsItem.product.componentList[0]
                                    .inventoryDetails[0].inventoryId;
                            orderDetailsItem.product.componentList.forEach(
                                (componentItem) => {
                                    // console.log('componentItem', componentItem);
                                    componentItem.inventoryDetails.length > 0 &&
                                        componentItem.inventoryDetails.forEach(
                                            (currentOrderDetailItem) => {
                                                if (
                                                    currentOrderDetailItem.quantity >
                                                    0
                                                ) {
                                                    let pickOrderComponentItemObj =
                                                        {
                                                            id: currentOrderDetailItem.id,
                                                            inventoryId:
                                                                currentOrderDetailItem.inventoryId,
                                                            sku: componentItem.sku,
                                                            quantity:
                                                                currentOrderDetailItem.quantity,
                                                            lot: currentOrderDetailItem.lot,
                                                            storeCondition:
                                                                componentItem.storeCondition,
                                                            shippingCondition:
                                                                componentItem.shippingCondition,
                                                            specifications:
                                                                componentItem.specifications,
                                                            lotExpirationDate:
                                                                currentOrderDetailItem.lotExpirationDate,
                                                            ddnsaDate:
                                                                currentOrderDetailItem.ddnsaDate,
                                                            dnsaDate:
                                                                currentOrderDetailItem.dnsaDate,
                                                        };
                                                    pickOrderProductItemsArry.push(
                                                        pickOrderComponentItemObj,
                                                    );
                                                }
                                            },
                                        );
                                },
                            );
                        }
                    } else {
                        if (
                            orderDetailsItem.product.inventoryDetails.length > 0
                        ) {
                            currentinventoryId =
                                orderDetailsItem.product.inventoryDetails[0]
                                    .inventoryId;
                            orderDetailsItem.product.inventoryDetails.forEach(
                                (detailItem) => {
                                    if (detailItem.quantity > 0) {
                                        let pickOrderItemObj = {
                                            id: detailItem.id,
                                            inventoryId: detailItem.inventoryId,
                                            sku: orderDetailsItem.product.sku,
                                            quantity: detailItem.quantity,
                                            lot: detailItem.lot,
                                            storeCondition:
                                                orderDetailsItem.product
                                                    .storeCondition,
                                            shippingCondition:
                                                orderDetailsItem.product
                                                    .shippingCondition,
                                            specifications:
                                                orderDetailsItem.product
                                                    .specifications,
                                            lotExpirationDate:
                                                detailItem.lotExpirationDate,
                                            ddnsaDate: detailItem.ddnsaDate,
                                            dnsaDate: detailItem.dnsaDate,
                                        };
                                        pickOrderProductItemsArry.push(
                                            pickOrderItemObj,
                                        );
                                    }
                                },
                            );
                        }
                    }
                    pickOrderProduct = {
                        orderProductId: orderDetailsItem.id,
                        productId: orderDetailsItem.product.id,
                        inventoryId: currentinventoryId,
                        kit: orderDetailsItem.product.sku,
                        kitFlag: orderDetailsItem.product.kitFlag,
                        tobeShippedQuantity:
                            orderDetailsItem.onholdQuantity +
                            orderDetailsItem.tobeshippedQuantity,
                        pickOrderProductItems: pickOrderProductItemsArry,
                    };
                    pickOrderProductsArr.push(pickOrderProduct);
                }
            });
        let orderCheckedObj = {
            orderId: currentOrderDetails.id,
            pickType: 'bySku',
            pickOrderProducts: pickOrderProductsArr,
            displayPrice: this.state.isShowPrice ? 1 : 2,
        };

        return orderCheckedObj;
    };

    getShipmentInfor = () => {
        this.props.hostDeliverToShip(this.props.match.params).then((res) => {
            if (res && res.data)
                res.data.orderProducts &&
                    res.data.orderProducts.length > 0 &&
                    res.data.orderProducts.map((item) => {
                        item.product.checked = false;
                        let params = {
                            shipmentItem: item,
                        };
                        this.initDeliverOrderQuantiys(params);
                    });
            this.setState({
                orderDetails: res.data,
                isShowPrice:
                    res.data.displayPrice === 0 || res.data.displayPrice === 1
                        ? true
                        : false,
            });
        });
    };

    onKeyReadMessageHandle = () => {
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        let currentEoneNum =
            typeof routerState.eoneNumber !== 'undefined'
                ? routerState.eoneNumber
                : '';
        this.props
            .oneKeyReadMessage({
                messageKey: currentEoneNum,
                messageMode: 'ORDER',
            })
            .then((res) => {
                this.getShipmentInfor();
                this.setState({
                    currentOrderIdMessageList: [],
                    orderMessageListDialog: false,
                    currentEoneNum: 0,
                });
            });
    };

    completedShippingPlanHandle = (planId) => {
        this.setState({
            completedShippingPlanDialog: true,
            currentPlanId: planId,
        });
    };

    markAsComplete = () => {
        const {currentPlanId, orderDetails} = this.state;
        let currentOrderDetails = JSON.parse(JSON.stringify(orderDetails));
        if (
            currentOrderDetails &&
            currentOrderDetails.orderProducts &&
            currentOrderDetails.orderProducts.length > 0
        ) {
            currentOrderDetails.orderProducts.map((orderProduct) => {
                if (
                    orderProduct.shippingPlan &&
                    orderProduct.shippingPlan.length > 0
                ) {
                    orderProduct.shippingPlan.map((planItem) => {
                        if (currentPlanId && currentPlanId === planItem.id) {
                            planItem.markComplete = true;
                        }
                    });
                }
            });
        }
        this.setState({
            orderDetails: currentOrderDetails,
        });
    };

    completedShippingPlanEvent = () => {
        const {currentPlanId} = this.state;
        this.props.completeShippingPlan({planId: currentPlanId}).then((res) => {
            console.log(
                'completedShippingPlanHandle-planId',
                currentPlanId,
                res,
            );
            if (res && res.status === 'success') {
                this.markAsComplete();
                this.setState(
                    {
                        completedShippingPlanDialog: false,
                    },
                    () => {
                        this.clearPlanId();
                    },
                );
            }
        });
    };

    clearPlanId = () => {
        this.setState({
            currentPlanId: 0,
        });
    };

    render() {
        const {
            orderDetails,
            isShowPrice,
            expressNumber,
            previewPickOrderDialog,
            confirmShipmentDialogOpened,
            shipmentCount,
            checkAll,
            orderMessageListDialog,
            currentOrderIdMessageList,
            completedShippingPlanDialog,
        } = this.state;
        let lang = loadLanguage();

        let routerState = util.getRouterState(
            this.props.history.location.state,
        );

        return (
            <div className="ship-edit-container">
                {typeof orderMessageListDialog !== 'undefined' &&
                !orderMessageListDialog ? (
                    <div>
                        <div className="header-wrap">
                            <div className="ship-edit-header container-max-width is-fixed">
                                <Anchor
                                    className="go-back"
                                    onClickOfSingleTap={this.goBack}>
                                    <ArrowBackIos />
                                </Anchor>
                                {T('shippment_select_lot_and_quantity')}
                            </div>
                        </div>
                        <ul className="products">
                            {orderDetails.orderProducts &&
                                orderDetails.orderProducts.map((item) => {
                                    return !item.product.kitFlag &&
                                        !item.product
                                            .inventoryDetails ? null : (
                                        <ProductItem
                                            key={item.id}
                                            item={item}
                                            orderType={orderDetails.orderType}
                                            shipmentSingleHandleCheck={
                                                this.shipmentSingleCheckHandle
                                            }
                                            orderStatus={orderDetails.status}
                                            counterValue={this.state.value}
                                            inputValid={(
                                                key,
                                                value,
                                                subLotId,
                                            ) => {
                                                this.inputValid(
                                                    key,
                                                    value,
                                                    item,
                                                    subLotId,
                                                );
                                            }}
                                            fromPage={
                                                FROM_PAGE.fromShipEditPage
                                            }
                                            completedShippingPlanHandle={
                                                this.completedShippingPlanHandle
                                            }
                                        />
                                    );
                                })}
                        </ul>
                        <div className="express-number">
                            <label>{T('shippment_express_number_colon')}</label>
                            <Input
                                className="express-number-input"
                                title="expressNumber"
                                value={expressNumber}
                                maxLength={20}
                                onChange={this.onChange}
                                placeholder={T('enter_express_number')}
                            />
                        </div>
                        <p
                            className={util.getClassName({
                                'show-price': true,
                                'text-center': true && lang !== 'EN',
                            })}>
                            {T('delivery_order_label')}
                            <label className="show-price-label">
                                {isShowPrice ? T('display') : T('not_display')}
                            </label>
                        </p>
                        <div className="select-delivery-order-is-display">
                            <div className="all-selected">
                                <Checkbox
                                    checked={
                                        shipmentCount > 0 ? checkAll : false
                                    }
                                    onChange={this.allSelectedShipmentHandle(
                                        'checkAll',
                                    )}
                                />
                                <span className="all-selected-title">
                                    {T('f1_order_receive_select_all')}
                                </span>
                            </div>
                            <div className="shipment-priview-pick-order">
                                <BasicButton
                                    className={util.getClassName({
                                        'confirm-ship-btn':
                                            true && lang !== 'EN',
                                        'en-confirm-ship-btn':
                                            true && lang === 'EN',
                                    })}
                                    testid="shipment-priview-pick-order-button"
                                    type="danger"
                                    disabled={
                                        shipmentCount <= 0 ||
                                        orderDetails.isPicking
                                            ? true
                                            : false
                                    }
                                    onClickOfSingleTap={
                                        this.shipmentPreviewPickOrderHandle
                                    }>
                                    {T('shipment_preview_pick_order')}
                                </BasicButton>
                            </div>
                            <div className="shipment-confirm-btn">
                                <BasicButton
                                    className={util.getClassName({
                                        'confirm-ship-btn':
                                            true && lang !== 'EN',
                                        'en-confirm-ship-btn':
                                            true && lang === 'EN',
                                    })}
                                    testid="shipment-confirm-button"
                                    type="primary"
                                    // disabled={ this.checkShipQuantity() || !submitBtnLoaded }
                                    disabled={shipmentCount <= 0}
                                    onClickOfSingleTap={
                                        this.shipmentLotConfirmHandle
                                    }>
                                    {T('shipment_delivery', [shipmentCount])}
                                </BasicButton>
                            </div>
                        </div>
                    </div>
                ) : null}

                <Dialog
                    opened={confirmShipmentDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('confirmShipmentDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className="tag-upload-dialog"
                        testid="shipment-confirm-dialog">
                        <h5 className="tag-upload-dialog-title text-center">
                            {T('confirm_delivery')}
                        </h5>
                        <p className="tag-upload-dialog-desc text-center">
                            {T('shipment_confirm_delivery')}
                        </p>
                        <div className="tag-upload-btn-container">
                            <BasicButton
                                type="primary"
                                className="receive-confirm-btn"
                                testid="shipment-confirm-dialog-confirm-btn"
                                onClickOfSingleTap={this.shipmentLotHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                testid="shipment-confirm-dialog-cancel-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'confirmShipmentDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={previewPickOrderDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewPickOrderDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-pick-order-dialog">
                        <h5 className="preview-pick-order-dialog-title text-center">
                            {T('shipment_pick_confirm_preview_pick_order')}
                        </h5>
                        <p className="preview-pick-order-dialog-desc text-center">
                            {T('shipment_pick_is_confirm_preview_pick_order')}
                        </p>
                        <div className="preview-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="preview-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmPreviewPickOrderHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'previewPickOrderDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog opened={orderMessageListDialog}>
                    <div className="message-list-dialog">
                        <h5 className="message-list-dialog-title text-center">
                            {T('shipment_pick_message_list_title')}
                        </h5>
                        <p className="message-list-content-container text-center">
                            <div className="order-num">
                                {/* <label>{T('order_eone_number')}: </label>
                                {typeof routerState.eoneNumber !== 'undefined' ? routerState.eoneNumber : ""} */}
                                <div className="message-eone-number">
                                    {T('order_eone_number')}:{' '}
                                    {typeof routerState.eoneNumber !==
                                    'undefined'
                                        ? routerState.eoneNumber
                                        : ''}
                                </div>
                                <div className="message-count">
                                    {T('shipment_pick_message_count', [
                                        currentOrderIdMessageList.length,
                                    ])}
                                </div>
                            </div>
                            {currentOrderIdMessageList.length > 0 &&
                                currentOrderIdMessageList.map((messageItem) => (
                                    <div className="message-list-container">
                                        <div className="from-to-user-container">
                                            <div className="from-to-user">
                                                <div className="message-left">
                                                    {messageItem.fromUserName !==
                                                    '系统提示'
                                                        ? T(
                                                              'host_message_list_admin',
                                                          )
                                                        : ''}
                                                    {messageItem.fromUserName}
                                                </div>
                                                {T(
                                                    'host_message_list_to_user_name',
                                                )}
                                                <div className="message-right">
                                                    {messageItem.toUserNameList
                                                        .length > 0
                                                        ? messageItem.toUserNameList.join(
                                                              '，',
                                                          )
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="message-content">
                                            <div className="content-value">
                                                {messageItem.content}
                                            </div>
                                        </div>
                                        <div className="message-time">
                                            <div className="time-value">
                                                {messageItem.createTime}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </p>
                        <div className="message-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.onKeyReadMessageHandle
                                }>
                                {T('shipment_pick_message_list_button_next')}
                            </BasicButton>
                            {/* <BasicButton type="primary" className="cancel-confirm-btn" onClickOfSingleTap={ () => this.dialogDidClose('orderMessageListDialog') }>{T('cancel')}</BasicButton> */}
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={completedShippingPlanDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('completedShippingPlanDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-pick-order-dialog">
                        <h3 className="preview-pick-order-dialog-title text-center">
                            {T('shipping_plan_complete_confirm_message')}
                        </h3>

                        <div className="preview-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="preview-pick-order-confirm-btn complete-shipping-plan-confirm-btn"
                                onClickOfSingleTap={
                                    this.completedShippingPlanEvent
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn complete-shipping-plan-cancel-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'completedShippingPlanDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    hostDeliverToShip,
    shipmentShip,
    createInvoicePdf,
    openNotification,
    getAllSkuConditionList,
    savePickOrder,
    getPickOrderMessageList,
    oneKeyReadMessage,

    completeShippingPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipEdit);
